import React, { useEffect } from 'react';
import Navbar from '../component/Navbar/NavbarCommon';
import ArrowButton from '../component/Common/ArrowButton';
import { useLocation } from 'react-router-dom';

const Products: React.FC = () => {
  const location = useLocation();

  // Scroll to anchor if hash is present in the location
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        // small timeout to ensure page layout is ready
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
      }
    } else {
      // scroll to top on page open without hash
      window.scrollTo({ top: 0 });
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main className="max-w-5xl mx-auto px-6 py-24 mt-14">
        <div className="mb-6">
          <ArrowButton />
        </div>
        <h1 className="text-3xl font-semibold text-gray-900 mb-8 text-center">Products</h1>

        {/* India Section */}
        <section id="india" className="mb-16">
          <h2 className="text-2xl font-semibold text-gray-900 mb-8 border-b-2 border-gray-200 pb-2">India</h2>

          {/* Horizontal Layout for AO Smith and Pureit */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* AO Smith India */}
            <div>
              <a
                href="https://www.aosmithindia.com/?srsltid=AfmBOooQmDsly5tfmDs3dM5wR4qgf2gTYudZGwX9vBzQut0fRE-rOpwW"
                target="_blank"
                rel="noopener noreferrer"
                className="block transition-transform hover:scale-105"
              >
                <div className="flex items-center gap-6 mb-4 p-4 rounded-lg hover:bg-gray-50 border border-gray-200 h-full">
                  <img
                    src="assets/logo-2.png"
                    alt="A. O. Smith India"
                    className="h-auto w-auto object-contain max-h-20"
                  />
                  <svg
                    className="w-5 h-5 text-gray-400 ml-auto"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </div>
              </a>
            </div>

            {/* Pureit India */}
            <div>
              <a
                href="https://www.pureitwater.com/?srsltid=AfmBOopgPqq3X8theFe3wHby9g50K80ahucHUYCO8sGUqv60hqjllv3v"
                target="_blank"
                rel="noopener noreferrer"
                className="block transition-transform hover:scale-105"
              >
                <div className="flex items-center gap-6 mb-4 p-4 rounded-lg hover:bg-gray-50 border border-gray-200 h-full">
                  <img
                    src="assets/pureit_water_logo.png"
                    alt="Pureit India"
                    className="h-auto w-auto object-contain max-h-20"
                  />
                  <svg
                    className="w-5 h-5 text-gray-400 ml-auto"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* Bangladesh Section */}
        <section id="bangladesh" className="mb-12">
          <h2 className="text-2xl font-semibold text-gray-900 mb-8 border-b-2 border-gray-200 pb-2">Bangladesh</h2>

          {/* Pureit Bangladesh */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <a
                href="https://bd.pureitwater.com/?utm_medium=search&utm_source=google-ads&utm_campaign=l-saliency-driving_CH1086_BH0735_BD&utm_content=brand_rsa-pureit-category&utm_term=2pd-demog-broad-ad2565&gclsrc=aw.ds&gad_source=1&gad_campaignid=20481789502&gbraid=0AAAAACz4nWlky_CArbg43pi1nmjUKsCGu&gclid=Cj0KCQiAiqDJBhCXARIsABk2kSlTQRaWu2I203yVbnduAmzZsOLxyPVbWdtra-84u8BKeCzbHkvAU_kaAiUCEALw_wcB"
                target="_blank"
                rel="noopener noreferrer"
                className="block transition-transform hover:scale-105"
              >
                <div className="flex items-center gap-6 mb-4 p-4 rounded-lg hover:bg-gray-50 border border-gray-200 h-full">
                  <img
                    src="assets/pureit_water_logo.png"
                    alt="Pureit Bangladesh"
                    className="h-auto w-auto object-contain max-h-20"
                  />
                  <svg
                    className="w-5 h-5 text-gray-400 ml-auto"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Products;
